type SVGProps = {
  width?: string | number;
  height?: string | number;
  className?: string;
};

const Question = ({ width, height, className }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    className={className}
    viewBox={`0 0 12 12`}
  >
    <g strokeWidth='1' fill='none' fillRule='evenodd'>
      <g>
        <g transform='translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) translate(0.000000, 0.000000)'>
          <path
            d='M6,10.5 C8.48528137,10.5 10.5,8.48528137 10.5,6 C10.5,3.51471863 8.48528137,1.5 6,1.5 C3.51471863,1.5 1.5,3.51471863 1.5,6 C1.5,8.48528137 3.51471863,10.5 6,10.5 Z'
            fillRule='nonzero'
          />
          <path
            d='M6,8.5 C6,8.16666667 6,8 6,8 C6.82842712,8 7.5,7.32842712 7.5,6.5 C7.5,5.67157288 6.82842712,5 6,5 C5.17157288,5 4.5,5.67157288 4.5,6.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            transform='translate(6.000000, 6.750000) rotate(-180.000000) translate(-6.000000, -6.750000) '
          />
          <circle strokeWidth='0.5' cx='6' cy='3.5' r='0.2' fill='6B6B6B' />
        </g>
      </g>
    </g>
  </svg>
);

export default Question;
